import { useCallback } from "react"


const isEmpty = (value) => value === undefined || value === null || value === ''

// Номер аналита — целое число больше нуля, иначе поле не участвует в проверке лимита аналитов.
const parseAnalyteNumber = (value) => {
  if (isEmpty(value) || typeof value === 'boolean') return undefined
  const number = Number(value)
  return Number.isInteger(number) && number > 0 ? number : undefined
}


export const useTableData = () => {

  const getControlData = useCallback((data, fieldName) => {
    return data[fieldName];
  }, [])


  const loadTableData = useCallback((schema, data) => {

    let tableData = []
    for (let i in schema.properties) {
      let tableRow = {
        "name": i,
        "type": schema.properties[i].type,
        //"analyte": schema.properties[i].prop_analyte,
        //"kv": schema.properties[i].prop_kv,
        //"measure": schema.properties[i].prop_measure,
        "minimum": schema.properties[i].minimum,
        "maximum": schema.properties[i].maximum,
        "decimal_places": schema.properties[i].decimal_places,
        "maxLength": schema.properties[i].maxLength,
        "analyte_number": schema.properties[i].analyte_number,
        "ais_upload": schema.properties[i].ais_upload,
        "export_rows": schema.properties[i].export_rows,
      }

      //console.log(i)
      //console.log(schema.properties[i])
      tableData.push(tableRow)
    }
    return tableData;
  }, [getControlData])


  const generateSchemafromTable = useCallback((schema, tableData) => {

    // Массив eas_special_rows будет взят из предыдущей schema
    const newSchema = JSON.parse(JSON.stringify(schema));
    delete newSchema.properties;
    newSchema.properties = {};

    for (let i in tableData) {
      const row = tableData[i]

      // Настройки поля, которых нет в таблице (filled, title, enum, format, ...), берём из текущей схемы.
      let props = JSON.parse(JSON.stringify(schema.properties?.[row.name] ?? {}))
      props.type = row.type
      props.ais_upload = row.ais_upload
      props.export_rows = row.export_rows

      for (const key of ['maximum', 'minimum']) {
        if (isEmpty(row[key])) {
          delete props[key]
        } else if (row.type === 'integer') {
          props[key] = parseInt(row[key])
        } else if (row.type === 'number') {
          props[key] = Number(row[key])
        } else {
          delete props[key]
        }
      }

      if (row.type === 'number' && !isEmpty(row.decimal_places)) {
        props.decimal_places = row.decimal_places
      } else {
        delete props.decimal_places
      }

      if (row.type === 'string' && !isEmpty(row.maxLength)) {
        props.maxLength = row.maxLength
      } else {
        delete props.maxLength
      }

      const analyteNumber = parseAnalyteNumber(row.analyte_number)
      if (analyteNumber === undefined) {
        delete props.analyte_number
      } else {
        props.analyte_number = analyteNumber
      }

      newSchema.properties[row.name] = props
    }

    return newSchema;
  }, [])


  return { 
    loadTableData,
    generateSchemafromTable 
  }

}
